import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import CategoryTags from '@stories/Components/CategoryTags/CategoryTags';
import * as React from 'react';
import S from './ContentCard.styles';
const ContentCard = (props) => {
    const srcs = props.image ? getSrcs(props.image, 1424, 375, 8, 354 / 226) : undefined;
    const sizes = `${until(Device.Tablet)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.Desktop)} 33vw, ${until(Device.DesktopLarge)} 25vw, 402px`;
    return (React.createElement(S.Container, { "data-has-image": !!props.image, "data-is-featured": props.featured ?? false, ...(props.cta ? { as: 'a', href: props.cta.url, target: props.cta.target } : {}) },
        srcs && (React.createElement(S.ImageContainer, null,
            props.restricted && (React.createElement(S.MemberAccess, null,
                React.createElement(S.MemberIcon, null, getSvgIcon(props.memberHasAccess ? InterfaceIcon.Unlocked : InterfaceIcon.Lock)),
                React.createElement("span", null, props.translations?.['global.memberaccesslabel']))),
            React.createElement(S.Image, { src: srcs.src, srcSet: srcs.srcSet, sizes: sizes, alt: props.image?.altText, loading: "lazy" }))),
        React.createElement(S.ContentWrapper, null,
            props.restricted && !srcs && (React.createElement(S.MemberAccess, null,
                React.createElement(S.MemberIcon, null, getSvgIcon(props.memberHasAccess ? InterfaceIcon.Unlocked : InterfaceIcon.Lock)),
                props.translations?.['global.memberaccesslabel'])),
            React.createElement(CategoryTags, { id: props.id, tags: props.categoryTags }),
            React.createElement(S.ContentArea, null,
                React.createElement(S.Heading, { as: props.headingType }, props.heading),
                props.showIcons || props.time || props.location ? (React.createElement(S.DateTime, null,
                    props.date && (React.createElement(S.Date, null,
                        getSvgIcon(InterfaceIcon.CalendarBlank),
                        React.createElement("span", null, props.date))),
                    props.time && (React.createElement(S.Time, null,
                        getSvgIcon(InterfaceIcon.Clock),
                        React.createElement("span", null, props.time))),
                    props.location && (React.createElement(S.Location, null,
                        getSvgIcon(InterfaceIcon.Location),
                        React.createElement("span", null, props.location))))) : null),
            React.createElement(S.BaseContentArea, { "data-just-button": !!props.date && !props.time },
                props.date && !props.time && !props.location ? React.createElement(S.Date, null, props.date) : null,
                props.cta && (React.createElement(FakeButton, { buttonType: "secondary", icon: InterfaceIcon.ArrowRight, iconOnly: true }))))));
};
export default ContentCard;
